export default __webpack_public_path__ + "static/salon-vid-n-a0205260fa8fc95c50f3c3aef20a41f1.mp4";